module.exports = __webpack_public_path__ + "static/media/loader.81d71520.svg";